const months = [
  'jan.',
  'fév.',
  'mars',
  'avr.',
  'mai',
  'juin',
  'juil.',
  'août',
  'sept.',
  'oct.',
  'nov.',
  'déc.'
]
const monthsFull = [
  'Janvier',
  'Février',
  'Mars',
  'Avril',
  'Mai',
  'Juin',
  'Juillet',
  'Août',
  'Septembre',
  'Octobre',
  'Novembre',
  'Décembre'
]

const weekdays = [
  'Dimanche',
  'Lundi',
  'Mardi',
  'Mercredi',
  'Jeudi',
  'Vendredi',
  'Samedi'
]

export const formatSwissDate = (a, type) => {
  const parts = a.split('-')
  const month = months[parseInt(parts[1]) - 1]
  const monthFull = monthsFull[parseInt(parts[1]) - 1]
  const day = weekdays[new Date(a).getDay()]
  if (type === 'short_chart') {
    return month + '.' + parts[0].substr(2, 2)
  }
  if (type === 'year_only') {
    return parts[0]
  }
  if (type === 'short') {
    return (
      parseInt(parts[2]) +
      '.' +
      parseInt(parts[1]) +
      '.' +
      parts[0].substr(2, 2)
    )
  }
  if (type === 'extended') {
    return day + ', ' + parseInt(parts[2]) + ' ' + month + ' ' + parts[0]
  }
  return parseInt(parts[2]) + ' ' + month + ' ' + parts[0]
}
// export const formatSwissDate = a =>
//   new Date(a).toLocaleDateString('ch-DE', {
//     day: 'numeric',
//     month: 'short',
//     year: 'numeric'
//   })
